import _ from "lodash";
import store from "services/redux/store";
import { constantsActive } from "utils/constants/constants";

const ObjectClass = {
	
	/**
	 * Check if the object is active
	 * @param object
	 * @returns {boolean}
	 */
	isActive: ( object ) => {
		return _.has( object, 'active' ) && _.get( object, 'active', constantsActive.YES ) === constantsActive.YES;
	},
	
	/**
	 *
	 * @param objects
	 * @returns {[]}
	 */
	filterActive: ( objects ) => {
		const filtered = [];
		
		_.forEach( _.filter( objects ), object => {
			if( ObjectClass.isActive( object ) ) {
				filtered.push( object );
			}
		})
		
		return filtered;
	},
	
	/**
	 *
	 * @param objects
	 * @param constantsKey
	 * @returns {[]}
	 */
	get: ( objects, constantsKey ) => {
		const _items = store.getState().data[ constantsKey ];
		
		const items = [];
		_.forEach( objects, object => {
			const _item = _.get( _items, object.guid, {} );
			
			if( !_.isEmpty( _item ) ) {
				items.push( _item );
			}
		})
		
		return items;
	},
	
	all: ( constantsKey ) => {
		return store.getState().data[ constantsKey ];
	},
	
	default: ( objects ) => {
		let defaultSelected = null;
		
		_.forEach( objects, object => {
			if( object['default'] === constantsActive.YES ) {
				defaultSelected = object['guid'];
			}
		});
		
		return defaultSelected;
	},
}

export default ObjectClass
